/* eslint-disable no-unused-vars */
/* eslint-disable react/prop-types */
import React from 'react';
import PropTypes from 'prop-types';
import { graphql } from 'gatsby';
import { Headline2 } from '@cdm/quickenloans-library/lib';
import Layout from '../../components/Templates/Layout';
import sanitizeHeader from '../../utilities/sanitizeHeader';
import addMetaRobots from '../../utilities/addMetaRobots';
import RelatedArticlesGrid from '../../components/Molecules/GridContainer';
import { globalTransformer, gridPropsTransformer } from '../../graphql/transformers';
import wpPageContentTransformer from '../../graphql/transformers/page/wpPageContent';
import parseHTML from '../../utilities/parseHTML';
import {defaultAttributes, testAttributes} from './Constants';
import WpPage from '../../components/Pages/WpPage';

import {
    globals,
    pageData
} from '../../graphql/fragments';
import { sanitizeBreadcrumbs } from '../../utilities/breadcrumbs';

const WpPageContainer = ({ data: queried, location=null }) =>
{
    const { headerProps, footerProps } = globalTransformer({ queried, location });
    let relatedArticles = null;
    const relatedArticlesProps = gridPropsTransformer({
        databaseId: 0,
        relatedPosts: queried?.relatedPosts,
        pinnedPosts: null
    });
    const { queryArgs: {posts:allPosts} } = relatedArticlesProps; 

    const { title, editorial, hasCtaBanner } = wpPageContentTransformer( {
        ...queried,
        allPosts
    });
    
    if ( queried?.page?.cdmfields?.grid?.show ) 
    {
        const articleGridTitle = queried.page.cdmfields?.grid?.label || "";
        const relatedArticlesTitle = (articleGridTitle && articleGridTitle.length) ? parseHTML( articleGridTitle ).parsed : defaultAttributes.RELATED_ARTICLES_TITLE;
        relatedArticles = [
            <Headline2 className="h2_bold" testId={testAttributes.RELATED_ARTICLES_TITLE} key="pgRelatedTitle">{relatedArticlesTitle}</Headline2>,
            <RelatedArticlesGrid {...relatedArticlesProps} key="pgRelatedGrid" />
        ]    
    }
   
    const breadcrumbs = sanitizeBreadcrumbs(queried?.page?.cdmfields?.breadcrumb);

    return (
        <Layout
            headerProps={headerProps}
            footerProps={footerProps}
            breadcrumbProps={breadcrumbs?.length > 1 ? breadcrumbs : undefined}
            hasHero={hasCtaBanner}
        >
            <WpPage 
                title={title} 
                editorial={editorial} 
                articles={relatedArticles}
                breadcrumbs={breadcrumbs?.length > 1 ? breadcrumbs : undefined}
            />
        </Layout>
    )
}

export const Head = ({ data: queried }) =>
{
    const { headMarkup, robots } = queried?.page?.cdmfields?.metadata ?? {};
    const headMetaData = addMetaRobots(robots, headMarkup);
    const hasCtaBanner = queried?.page?.content?.includes('id="ql-cta-banner-breadcrumbs"');

    return <>
        {sanitizeHeader(headMetaData).parsed}
        <html lang="en" />
        <body data-type="page" data-id={queried?.page?.databaseId} className={`${hasCtaBanner ? '' : 'QLD_ROOT'}`} />
    </>
}

export const pageQuery = graphql`
    query wpPageContentQuery(
        $id: String!
    ) {
        ...globals
        page: wpPage( id: { eq: $id } ) {
            ...pageData
        }
        relatedPosts: allWpPost {
            edges {
                node {
                    ...postCardData
                }
            }
        }
    }
`;
WpPageContainer.propTypes = {
    data: PropTypes.object,
    previewData: PropTypes.object,
    location: PropTypes.oneOfType([
        PropTypes.object,
        PropTypes.string,
        PropTypes.oneOf([null]),
    ]),
}


export default WpPageContainer;
